import { html, TemplateResult } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { OutlineVideoYoutube } from '../../base/outline-video-youtube/outline-video-youtube';

import { IframeApiType, YouTubePlayer } from './type';

declare global {
  interface Window {
    YT: IframeApiType;
  }
}

/**
 * The GHS VideoYoutube component
 *
 * @element ghs-video-youtube
 */
@customElement('ghs-video-youtube')
export class GhsVideoYoutube extends OutlineVideoYoutube {
  @property({ type: String, attribute: 'video-id', reflect: true })
  videoID: string;

  @query('#video')
  videoEl: HTMLElement;

  player: YouTubePlayer;

  constructor() {
    super();

    const youtubeScript = document.querySelector(
      'script[src="https://www.youtube.com/player_api"]'
    );

    // Check if the youtube player script has already been added.
    if (!youtubeScript) {
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/player_api';

      // Add youtube player api script.
      document.head.append(script);
    }
  }

  firstUpdated(): void {
    super.firstUpdated();
    const yInterval = setInterval(() => {
      const YT = window.YT;

      if (YT && YT.loaded === 1) {
        clearInterval(yInterval);

        this.player = new YT.Player(this.videoEl, {
          height: '360',
          width: '640',
          host: 'https://www.youtube-nocookie.com',
          videoId: this.videoID,
          playerVars: {
            playsinline: 1,
          },
        });
      }
    }, 500);
  }

  render(): TemplateResult {
    return html` <div id="video"></div> `;
  }
}
